import { isFinite } from 'lodash'
import PropTypes from 'prop-types'

import { ArrowDown, ArrowUp, Infinite, Minus } from '@/components/Icons'

const DifferenceTool = ({ currentTotal, previousTotal, color, className }: any) => {
  const difference = calculateDifference({ currentTotal, previousTotal })
  return (
    <div className={className} style={{ display: 'contents' }}>
      {getIcon(difference.icon, color)}
      <div>
        {isFinite(difference.value) ? (
          <h3 style={{ color: color }}>{`${setNumberMax(difference.value)}%`}</h3>
        ) : (
          <Infinite style={{ color }} />
        )}
      </div>
    </div>
  )
}

const calculateDifference = ({ currentTotal, previousTotal }: any) => {
  if (currentTotal < previousTotal)
    return { icon: 'down', value: Math.round(((previousTotal - currentTotal) / currentTotal) * 100) }
  else if (currentTotal > previousTotal)
    return { icon: 'up', value: Math.round(((currentTotal - previousTotal) / previousTotal) * 100) }
  else return { icon: 'level', value: 0 }
}

const setNumberMax = (number: any) => {
  if (number > 999 && number !== 'Infinity') return '+999'
  return number
}

const getIcon = (icon: any, color: any) => {
  if (icon === 'up') return <ArrowUp style={{ color }} />
  else if (icon === 'down') return <ArrowDown style={{ color }} />
  else return <Minus style={{ color }} />
}

DifferenceTool.displayName = 'DifferenceTool'

DifferenceTool.defaultProps = {
  color: 'black',
  className: ''
}

DifferenceTool.propTypes = {
  currentTotal: PropTypes.number.isRequired,
  previousTotal: PropTypes.number.isRequired,
  color: PropTypes.string,
  className: PropTypes.string
}

export default DifferenceTool
